import React, { useContext, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import productData from "../Datas/productData";
import Footer from "./Footer";
import "../css/productdetails.scss";
import { CartContext } from "../Component/CartContext";
import Header from "./Header";

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const product = productData.find((item) => item.id === parseInt(id));
  const { addToCart } = useContext(CartContext);

  const [selectedSize, setSelectedSize] = useState(product?.size?.[0] || "");
  const [selectedColor, setSelectedColor] = useState(
    product?.colors?.[0] || ""
  );
  const [selectedImage, setSelectedImage] = useState(0);
  const [quantity, setQuantity] = useState(1);

  if (!product) {
    return (
      <div className="product-detail">
        <Header />
        <div className="product-detail__not-found">
          <h2>Product not found</h2>
          <Link to="/shop">Back to Shop</Link>
        </div>
        <Footer />
      </div>
    );
  }

  const handleAddToCart = () => {
    addToCart(product.id, 1, selectedSize, selectedColor);
    navigate("/cartpage");
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const setImage = (idx) => {
    setSelectedImage(idx);
  };

  return (
    <div className="product-detail">
      <Header />

      <main className="product-container container">
        <nav className="breadcrumb">HOME &nbsp; &gt; &nbsp; {product.name}</nav>

        <div
          className="product-grid"
          style={{ gridTemplateColumns: "repeat(2,1fr)" }}
        >
          <div className="product-gallery">
            <div className="main-image">
              <img
                src={product.images?.[selectedImage] || product.image}
                alt={product.name}
              />
            </div>

            <div className="thumbs">
              {(product.images || [product.image]).map((src, idx) => (
                <button
                  key={idx}
                  className={`thumb ${selectedImage === idx ? "active" : ""}`}
                  onClick={() => setImage(idx)}
                  aria-label={`View image ${idx + 1}`}
                >
                  <img src={src} alt={`${product.name}-${idx}`} />
                </button>
              ))}
            </div>
          </div>

          <div className="product-info">
            <h1 className="product-title">{product.name}</h1>

            <div className="price-row">
              {(() => {
                const sale = Number(product.price);
                const original = product.originalPrice
                  ? Number(product.originalPrice)
                  : Number((sale * 1.2).toFixed(2));
                const savePercent =
                  original > sale ? Math.round((1 - sale / original) * 100) : 0;
                return (
                  <>
                    <div className="prices">
                      {original > sale && (
                        <span className="original-price">
                          ${original.toFixed(2)}
                        </span>
                      )}
                      <span className="sale-price">${sale.toFixed(2)}</span>
                    </div>
                    {savePercent > 0 && (
                      <span className="save-badge">Save {savePercent}%</span>
                    )}
                  </>
                );
              })()}
            </div>

            <div className="rating-row">
              <div className="stars" aria-hidden>
                {Array.from({ length: 5 }).map((_, i) => {
                  const filled = i < Math.round(Number(product.rating || 0));
                  return (
                    <span key={i} className={`star ${filled ? "filled" : ""}`}>
                      ★
                    </span>
                  );
                })}
              </div>
              <div className="reviews-count">{product.reviews} reviews</div>
            </div>

            <div className="option-row">
              <div className="option-label">Color:</div>
              <div className="sizes">
                {(product.colors || []).map((s) => (
                  <button
                    key={s}
                    className={`size ${selectedColor === s ? "selected" : ""}`}
                    onClick={() => setSelectedColor(s)}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>

            <div className="option-row">
              <div className="option-label">Size:</div>
              <div className="sizes">
                {(product.size || []).map((s) => (
                  <button
                    key={s}
                    className={`size ${selectedSize === s ? "selected" : ""}`}
                    onClick={() => setSelectedSize(s)}
                  >
                    {s}
                  </button>
                ))}
              </div>
            </div>

            <div className="add-row">
              <div className="qty">
                <button onClick={() => setQuantity((q) => Math.max(1, q - 1))}>
                  −
                </button>
                <input type="text" readOnly value={quantity} />
                <button onClick={() => setQuantity((q) => q + 1)}>+</button>
              </div>

              <button className="add-to-cart" onClick={handleAddToCart}>
                Add To Cart
              </button>
            </div>

            <div className="benefits-row">
              <div className="benefit">
                🚚 Free shipping within continental US
              </div>
              <div className="benefit">↩ 30 day returns</div>
            </div>

            <div className="product-features">
              <h3>Product Features</h3>
              <ul>
                {(product.Features || []).map((f, idx) => (
                  <li key={idx}>{f}</li>
                ))}
              </ul>

              <h3>Product Description</h3>
              <ul>
                {(product.description || []).map((f, idx) => (
                  <li key={idx}>{f}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ProductDetail;
